import LIST, { Collapse, Collapsible, EL, Expand, LI } from '../../../DOM/LIST/LIST.js';
import { HTMLELEMENT } from '../../../../enums/HTMLELEMENT.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { makeStruct } from '../../../../enums/MODELS.js';
// Model Structure
export const olAttr = makeAttrStruct([
    ['class'],
    ['name'],
    ['start', 1],
    ['reversed', false]
]);
export const olData = makeDataStruct([]);
export const olModel = makeStruct([
    ['attributes', olAttr],
    ['data', olData]
]);
// Simplified Model
export function ol(className, name, start, reversed) {
    return olModel(olAttr(className, name, start, reversed), olData());
}
/** Ordered List */
export default class OL extends LIST {
    constructor(node, model) {
        super(node, HTMLELEMENT.OL, model);
        if (model.attributes.reversed) {
            this.el.reversed = true;
        }
        else {
            this.removeAttribute('reversed');
        }
    }
}
export { Collapse, Collapsible, EL, Expand, LI, LIST };
